import { CheckCircle2, MailOpen } from "lucide-react";
import Navbar from "../../../components/layout/Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { loginRedirectLogic } from "../Login";
import { selectCurrentUser, selectToken } from "../../../features/authSlice";

const VerifySuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = useSelector(selectCurrentUser);
  const token = useSelector(selectToken);

  const handleProceed = () => {
    // Fallback just in case Redux hasn't hydrated
    if (!currentUser) {
      navigate("/login");
      return;
    }

    loginRedirectLogic(navigate, {
      user: currentUser,
      access: token || "",
      refresh: "", 
    });
  };

  useEffect(() => {
    
    if (!location.state?.verified) {
      navigate("/login", { replace: true });
      return;
    }
    window.fbq && window.fbq("track", "InitiateRegistration");

    const timer = setTimeout(() => {
      handleProceed();
    }, 3000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, currentUser, token]);

  return (
    <div>
      <Navbar />
      <div className="p-5 sm:p-14 h-[81vh] flex items-start md:items-center justify-center landing-bg bg-cover bg-no-repeat bg-center">
        <div className="w-full md:w-fit flex items-center justify-center flex-col bg-white">
          <div className="sm:p-10 rounded-2xl sm:border border-[#7E57C233] w-full sm:w-[80%] md:w-fit flex items-center justify-between gap-20">
            <div className="flex flex-col gap-6 items-center justify-start w-[500px]">
              <div className="flex items-center justify-center gap-2 relative">
                <MailOpen size={150} strokeWidth={0.2} color="#E5E5E5" />
                <CheckCircle2
                  className="absolute bottom-0 right-0 fill-white"
                  strokeWidth={2}
                  color="#7AC455"
                />
              </div>

              <div className="flex flex-col items-center justify-center gap-6 w-full">
                <h3 className="font-medium">
                  Email Verification Successful
                </h3>
                <span className="text-center text-[#A3A3A3]">
                  You'll be redirected automatically in 3 seconds.
                </span>
                <button
                  onClick={handleProceed}
                  className="mt-4 px-5 py-2 rounded-lg primary-btn cursor-pointer"
                >
                  Proceed
                </button>

                <span className="text-center text-[#A3A3A3]">
                  If you haven’t performed this action, kindly ignore this email
                  and write us at{" "}
                  <a
                    href="mailto:support@jellosite.com"
                    className="text-[#945bf5]"
                  >
                    support@jellosite.com
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifySuccess;